import { FC } from 'react';
import { Select, SelectProps } from 'antd';
import classNames from 'classnames';
import style from './index.module.less';
import ArrowDownSvg from '@/assets/imgs/arrow_down.svg?react';

export type CustomSelectProps = SelectProps;

const CustomSelect: FC<SelectProps> = ({ className, ...restProps }) => (
  <Select className={classNames(style.customSelect, className)} suffixIcon={<ArrowDownSvg />} {...restProps} />
);

export default CustomSelect;
